<template>
  <div>
    <div>
      <div
        class="object-last-seen"
      >
        <router-link-simple
          :to="objectData.seoLinkObject ? objectData.seoLinkObject : { name: 'ObjectPage', params: { objectNumber: objectData.objectNumber } }"
          data-ident="scrollTop"
          @click.native="scrollToTop"
        >
          <div class="img">
            <lazy-photo
              v-if="objectData.objectImages[0].src"
              :img-src="objectData.objectImages[0].src"
              :img-type="'objectGrid'"
              :img-title="objectData.objectImages[0].description"
              :object-number="objectData.objectNumber"
            />
          </div>
          <div class="content">
            <div
              v-dompurify-html="objectData.title"
              class="title"
            />
            <div class="location">
              {{ locationOfObject }}
            </div>
            <div
              class="rating"
            >
              <rating-stars-canvas
                v-if="objectData.ratingAverage"
                :average="objectData.ratingAverage"
                :rating-count="objectData.ratingCount"
                :show-average="true"
              />
            </div>
            <object-price-per-week
              :price-min="objectData.price"
              :show-decimals="false"
            />
          </div>
        </router-link-simple>
        <div
          v-if="lastSeenObjects"
          class="object-options"
        >
          <watch-btn
            v-if="objectData.objectNumber"
            :object-number="objectData.objectNumber"
            :min-price="objectData.price"
            :extra-class="'watch-btn-last-seen-object'"
          />
        </div>
      </div>
      <!-- <div v-else> -->
      <!-- you cant see me, i am an error object placeholder -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import ObjectPricePerWeek from 'components/ObjectPricePerWeek.vue';
import WatchBtn from 'components/WatchBtn.vue';
import LazyPhoto from 'components/LazyPhoto.vue';
import RouterLinkSimple from 'components/RouterLinkSimple.vue';
import RatingStarsCanvas from 'components/RatingStarsCanvas.vue';

export default {
  name: 'ObjectsPreview',
  components: {
    ObjectPricePerWeek,
    WatchBtn,
    LazyPhoto,
    RouterLinkSimple,
    RatingStarsCanvas,
  },
  props: {
    objectData: {
      type: [Object, Array],
      required: true,
    },
    lastSeenObjects: {
      type: Boolean,
      default: true,
    },
    locationOfObject: {
      type: String,
      required: true,
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

};
</script>


<style lang="scss" scoped>
  .content{
    .location{
      @include ellipsis;
      display:block;
      height:1.3rem;
    }
    .rating{
      height:1rem;
    }
  }
</style>
